// User
import interventionList from '../pages/intervention/interventionList.vue';
import createIntervention from '../pages/intervention/createIntervention.vue';
import editIntervention from '../pages/intervention/editIntervention.vue';
import interventionPackageList from '../pages/intervention/packageList.vue';
import ageGroupInt from '../pages/intervention/ageGroup.vue';

const routes = [
  { // /interventions
    path: '/interventions',
    name: 'package-intervention-list',
    component: interventionPackageList,
    meta:{
      name: 'Interventions',
      requireAuth: true
    },
  },
  { // /interventions/age-group
    path: '/interventions/age-group',
    name: 'intervention-age-group',
    component: ageGroupInt,
    meta:{
      name: 'Interventions Age Group',
      requireAuth: true
    },
  },
  { // package/:package_id/intervention/:trait_id
    path: 'package/:package_id/intervention/:trait_id',
    name: 'intervention-list',
    component: interventionList,
    meta:{
      name: 'Intervention List',
      requireAuth: true
    },
    props: true
  },
  { // package/:package_id/intervention/:trait_id/new
    path: 'package/:package_id/intervention/:trait_id/new',
    name: 'new-intervention',
    component: createIntervention,
    meta:{
      name: 'Create Intervention',
      requireAuth: true
    },
    props: true
  },
  { // interventions/:id
    path: 'interventions/:id',
    name: 'edit-intervention',
    component: editIntervention,
    meta:{
      name: 'Edit intervention',
      requireAuth: true
    },
    props: true
  },
]

export default routes